'use client';

import { lazy } from 'react';

const Calendar = lazy(() =>
  import('./tours-calendar-runtime').then(m => ({ default: m.ToursCalendar })),
);

// Keep SSR and the outer route boundary; don't ship the calendar on every page.
export function ToursCalendar() {
  return <Calendar />;
}
